module.exports = __webpack_public_path__ + "static/media/right-neighbour.5d243667.svg";